<template>
    <v-container fluid>
        <v-layout column>
            <h1>Aanvragen</h1>
            <p>Als je mij wilt aanvragen kan dat op de volgende manieren:</p>
            <ul>
                <li>U kunt mij rechtstreeks vragen, zie de <a href='/contact'>contactpagina</a>.</li>
                <li>Via <a href='https://tolkcontact.nl'>tolkcontact.nl</a> voor leefuren, werk- en onderwijsuren.</li>
            </ul>
            <p></p>
            <p>Voor een schrijftolk heb je tolkuren nodig. Voor het aanvragen of meer informatie zie de <a href='https://www.tolkcontact.nl/tolkgebruiker/wanneer-een-tolk-regelen/'>website tolkcontact.nl</a> over vergoedingen.</p>

            <p>Wil je weten hoe SchrijftolkVoorJou omgaat met persoonsgegevens? Lees daarvoor de <a href='/privacyverklaring'>privacyverklaring</a>.</p>
        </v-layout>
    </v-container>
</template>
<script>
export default {
    name: 'Disclaimer'
}
</script><style scoped>
</style>
